<div class="static-container">
    <div class="tab-container" #tabContainer>
        <ng-content select="[left-button]"></ng-content>
        <div class="tab-wrapper" #tabWrapper>
            <ng-content></ng-content>
        </div>
        <ng-content select="[right-button]"></ng-content>
    </div>
</div>